import { apiGlobal } from './index'
import { LOCAL_STORAGE } from '@utils/Const'

const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)

export const learnPartThreeEndPoints = {
  INIT_SESSION: 'iesv/api/v1/ielts/learning/sessions',
  GET_DATA: 'iesv/api/v1/ielts/learning/sessions',
  STT: 'iesv/api/v1/ielts/learning/retrieve-texts',
  GET_SCORE: 'iesv/api/v1/ielts/learning/sessions',
  UPGRADE_IDEA: 'iesv/api/v1/ielts/learning/sessions',
  GET_PRACTICE_IDEAS: 'iesv/api/v1/ielts/learning/sessions',
  GET_PRACTICE_LESSON_FRAME: 'iesv/api/v1/ielts/learning/sessions',
  GET_PRACTICE_LESSON_BODY: 'iesv/api/v1/ielts/learning/sessions',
  GET_SUMMARY: 'iesv/api/v1/ielts/learning/sessions',
  SAVE_STEP: 'iesv/api/v1/ielts/learning/sessions',
  GET_SUGGESTION: 'iesv/api/v1/ielts/learning/sessions',
  GET_FRAMES_SCORE: 'iesv/api/v1/ielts/learning/sessions',
}

const learnPartThreeRequest = {
  initSession: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(learnPartThreeEndPoints.INIT_SESSION, params)
    }
  },
  getData: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${learnPartThreeEndPoints.GET_DATA}/${params.session_id}`,
        {},
      )
    }
  },
  stt: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(learnPartThreeEndPoints.STT, params, {}, true)
    }
  },
  getScore: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${learnPartThreeEndPoints.GET_SCORE}/${params?.session_id}/part-3-scores`,
        params?.data, {}, true
      )
    }
  },
  upgradeIdea: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${learnPartThreeEndPoints.UPGRADE_IDEA}/${params?.session_id}/submit_ideas`,
        params,
      )
    }
  },
  getPracticeIdeas: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${learnPartThreeEndPoints.GET_PRACTICE_IDEAS}/${params?.session_id}/practice-ideas`,
        params,
      )
    }
  },
  getPracticeLessonFrame: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${learnPartThreeEndPoints.GET_PRACTICE_LESSON_FRAME}/${params?.session_id}/practice-lessons/frames`,
        {},
      )
    }
  },
  getPracticeLessonBody: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${learnPartThreeEndPoints.GET_PRACTICE_LESSON_BODY}/${params?.session_id}/practice-lessons/bodies`,
        {},
      )
    }
  },
  getSummary: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${learnPartThreeEndPoints.GET_SUMMARY}/${params?.session_id}/summaries`,
        {},
      )
    }
  },
  saveStep: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${learnPartThreeEndPoints.SAVE_STEP}/${params?.session_id}/steps`,
        params,
      )
    }
  },
  getSuggestion: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${learnPartThreeEndPoints.GET_SUGGESTION}/${params?.session_id}/explain-samples`,
        {},
      )
    }
  },
  getFramesScore: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${learnPartThreeEndPoints.GET_FRAMES_SCORE}/${params?.session_id}/practice-lessons/frames/scores`,
        params?.data, {}, true
      )
    }
  },
}

export default learnPartThreeRequest
